import React from 'react'
import { useSelector } from 'react-redux';
import Classification from '../../service-steps/treatment/classification';
import TreatmentResult from '../../service-steps/treatment/treatment-result';
import Goals from '../../service-steps/treatment/goals';
import History from '../../service-steps/treatment/history';
import NonPharmacological from '../../service-steps/treatment/non-pharmacological';
import Pharmacological from '../../service-steps/treatment/pharmacological';

const Treatment = () => {  
    const { clinicalServiceObj } = useSelector((state) => state.clinicalService);
    const { currentSubStep } = clinicalServiceObj.initialAssessment.initialAssessmentForm;
  
      const renderStep = () => {
        const subStep = currentSubStep === 0 ? 1 : currentSubStep;
        switch (subStep) {
          case 1:
            return <Classification />;
          case 2:
            return <TreatmentResult />;
          case 3:
            return <Goals />;
          case 4:
            return <History />; 
          case 5:
            return <NonPharmacological />;
          case 6:
            return <Pharmacological />;
        }
      }
      return renderStep();
  }

export default Treatment;